<template>
  <div id="app">
    <!-- <NavMenu></NavMenu> -->
    <router-view></router-view>
    <!-- <Overlayer></Overlayer> -->
  </div>
</template>

<script>
import "./App.css";

export default {
  name: "App",
  components: {},
};
</script>

<style>
#app {
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #fff;
  /* 点击出现蓝框问题 */
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  overflow: hidden;
}
.nav_menu {
  z-index: 999;
}
.homepages {
  z-index: 1;
}
.space {
  height: 30px;
}
</style>
